import React from 'react'
import NoContent from "./NoContent";
import HCLDX from "@system/config/hcldx";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const Manufacturers = (props) => {
    const { manufacturerList, searchText } = props;

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, 'Manufacturers', obj?.Name, (HCLDX.baseURL() + obj?.Url));
    }
    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Manufacturers</div>
            {Object.keys(manufacturerList).length > 0 &&
                <>
                    <div className="search-product-list">
                        {Object.keys(manufacturerList).length > 0 && Object.entries(manufacturerList).map((v, i) => (
                            <React.Fragment key={i}>
                                {i < 5 &&
                                    <div className="search-product-list-item">
                                        <div className='search-product-list-item-info'>
                                            <a onClick={() => typeHeadSearchEvent(v[1])} href={HCLDX.baseURL() + v[1].Url} className=" cursor-pointer" key={i}>
                                                <div className="search-product-list-info-title">{v[1].Name}</div>
                                            </a>
                                            <div className="search-product-list-info-desc">{v[1].Description}</div>
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        ))
                        }
                    </div>
                </>
            }
            {Object.keys(manufacturerList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Manufacturers